<template>
  <div v-if="!addReferralCodeActive">
    <a @click="addReferralCodeActive = !addReferralCodeActive">
      Edit
    </a>
  </div>
  <div v-else class="items-flex">
    <v-text-field
      v-if="addReferralCodeActive"
      v-model="addReferralCodeInput"
      type="text"
      class="pa-0 ma-0"
      hide-details
    />
    <a @click="addReferralCodeAction">
      Ok
    </a>
  </div>
</template>

<script>
import { adminAddReferralCode } from '@/lib/api.js'

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    addReferralCodeActive: false,
    addReferralCodeInput: null,
  }),
  methods: {
    async addReferralCodeAction() {
      try {
        await adminAddReferralCode(this.user._id, this.addReferralCodeInput)
        this.addReferralCodeActive = false
        this.$emit('loadItems')
      } catch (error) {
        this.$root.$snackbar.error({ text: this.$t('common.saveError') })
      }
    },
  },
}
</script>
